import React from 'react'
import { StaticQuery, Link } from 'gatsby'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import * as utils from './common/utils'
import styles from './Services.module.scss'
// components
import Title from '../images/svg/head_services.svg'
import Sunny from '../images/svg/icon_sunny.svg'
import IconCreative from '../images/svg/icon_services_creative.svg'
import IconPlanning from '../images/svg/icon_services_planning.svg'
import ArrowRight from '../images/svg/icon_arrow-right.svg'

const icons = {
    creative: <IconCreative />,
    planning: <IconPlanning />
};

const Services = () => (
    <StaticQuery
        query = {graphql`
            query ServicesQuery {
                allServicesJson {
                    edges {
                        node {
                            services {
                                id
                                title
                                title_en
                                description
                                mainimg_filename
                                subimg_filenames
                                link_url
                                icon_name
                            }
                        }
                    }
                }
            }
        `
        }
        render={data => {
            const services = data.allServicesJson.edges[0].node.services;
            return (
                <section name="services" className={styles.wrapper}>
                    <div className={styles.container}>
                        <h2 className="sr-only">事業概要</h2>
                        <div className={styles.head}>
                            <Title />
                        </div>
                    </div>
                    <div className={styles.items}>
                        {services.map(item => <Item key={shortid.generate()} item={item} />)}
                    </div>
                </section>
            )
        }}
    />
)

const Item = ({ item }) => {
    const Icon = () => icons[item.icon_name];

    return (
        <div 
            className={styles.item}
        >
            <div className={styles.itemHeader}>
                <div className={styles.itemThumb}>
                    <div className={styles.itemThumbInner}>
                        <div className={styles.itemThumbBg}>
                            <img src={`/images/${item.subimg_filenames[0]}`} alt=""/>
                        </div>
                    </div>
                </div>
                <div 
                    className={`${styles.itemThumb} ${styles.itemThumbMain}`}
                >
                    <div className={styles.itemThumbInner}>
                        <div className={styles.itemThumbBg}>
                            <img src={`/images/${item.mainimg_filename}`} alt=""/>
                        </div>
                        <div className={styles.itemThumbContent}>
                            <div className={styles.itemThumbLogo}>
                                <Icon />
                            </div>
                            {/* <div className={styles.itemThumbText}>
                                <div className={styles.itemThumbSubhead}>
                                    {item.title}
                                </div>
                                <div className={styles.itemThumbTitle}>
                                    {item.title_en}
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className={styles.itemThumb}>
                    <div className={styles.itemThumbInner}>
                        <div className={styles.itemThumbBg}>
                            <img src={`/images/${item.subimg_filenames[1]}`} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.itemBody}>
                <div className={styles.itemBodyInner}>
                    <h3 className={styles.itemTitle}>
                        {item.title}
                    </h3>
                    <div 
                        className={styles.itemDesc}
                        dangerouslySetInnerHTML={{__html: item.description}}
                    />
                    <div className={styles.itemBtnWrapper}>
                        <a 
                            className={styles.itemBtnCta}
                            href={item.link_url}
                        >
                            お問合せ・ご依頼はこちら
                            <div className={styles.itemBtnIcon}>
                                <Sunny />
                                <ArrowRight />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Services;
